exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AnswerType5{color:#000;font-size:18px;line-height:40px;position:relative}.AnswerType5 .blockedAnswer{width:100%;height:100%;z-index:100;position:absolute;top:0;left:0}.AnswerType5 .inp_ans{min-width:80px;width:80px;font-size:18px;line-height:18px!important;max-width:500px;border:1px solid #d9d9d9;padding:4px 8px;height:32px;color:#000000d9;margin-left:3px;margin-right:3px}.AnswerType5 .inp_ans.isTrue{border-color:#52c41a!important;background-color:#d9f7be}.AnswerType5 .inp_ans.isFalse{border-color:#cf1322!important;background-color:#fff1f0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/components/Answers/components/AnswerType5/style.module.scss
// module id = 5245
// module chunks = 0